import React from "react";
import styled from "styled-components/macro";
import { faMicrophone as faMicrophoneSolid, faStop } from "@duocards/pro-solid-svg-icons";
import { ControlButton } from "./ControlButton";
import useSpeechTapHold from "hooks/useSpeechTapHold";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 10px;
  padding: 10px;
`;

type Props = {
  onTranscription: (text: string) => void;
  languages?: string[];
  disabled?: boolean;
  className?: string;
};

export const SpeakingControls: React.FC<Props> = ({ onTranscription, languages, disabled, className }) => {
  const { transcribing, listening, supported, handlers, otherRecording } = useSpeechTapHold({
    onTranscription,
    languages,
    stopAfterMs: 30000,
    forceMp3: true
  });

  if (!supported) return null;

  return (
    <Container className={className}>
      <ControlButton
        {...handlers}
        icon={listening ? faStop : faMicrophoneSolid}
        disabled={otherRecording || disabled}
        loading={transcribing}
      />
    </Container>
  );
};

export default SpeakingControls;
